import { defineStore } from 'pinia';
import { ref, computed } from 'vue';

export const useCompanyStore = defineStore('company', () => {
  const currentCompany = ref(localStorage.getItem('selectedCompany'));
  const myCompanies = ref([]);
  
  const setCompany = (companyId) => {
    currentCompany.value = companyId;
    localStorage.setItem('selectedCompany', companyId);
  };

  const clearCompany = () => {
    currentCompany.value = null;
    localStorage.removeItem('selectedCompany');
    myCompanies.value = [];

    console.log('COMPANY', currentCompany.value);
  };

  const isEmptyCompany = computed(() => [null, undefined, 'null', 0].includes(currentCompany?.value));

  const companyId = computed(() => Number(currentCompany?.value));

  const setMyCompanies = (companies) => {
    myCompanies.value = Array.isArray(companies) ? companies : [];
  };

  const hasMultipleCompanies = computed(() => myCompanies.value.length > 1);

  return {
    currentCompany,
    myCompanies,
    hasMultipleCompanies,
    isEmptyCompany,
    companyId,
    setCompany,
    setMyCompanies,
    clearCompany
  };
});
